import dayjs from "dayjs";
import { useForecastContext } from "../../../../../context/forecastContext";
import SkeletonLoader from "../../../../SkeletonLoader";
import ErrorMessage from "../../../../errorMessage/errorMessage";
import { findForecastForDay } from "../../../../../utilities/forecastHelpers";
import { useTheme } from "../../../../../context/themeContext";
import { Format, Span, Tooltip } from "@tag/tag-components-react-v4";
import { PlusLined } from "@tag/tag-icons";
import { useForecastQuery } from "../../../../../services/forecastService";

type MonthDayRevenueProps = {
  day: dayjs.Dayjs;
};

const MonthDayRevenue: React.FC<MonthDayRevenueProps> = ({ day }) => {
  const { forecastState } = useForecastContext();
  const { theme } = useTheme();
  const {
    data: forecasts,
    isLoading,
    isError,
  } = useForecastQuery({
    mdrSiteId: forecastState.selectedSite?.mdrSiteId!,
    siteId: forecastState.selectedSite?.siteId!,
    orgId: forecastState.selectedSite?.organisationId!,
    searchPeriod: forecastState.searchPeriod,
  });

  if (isLoading) {
    return <SkeletonLoader />;
  }
  // to-do - this doesnt look right - fix it
  if (isError) {
    return <ErrorMessage showMessage={false} dataType="" fontSize="8px" />;
  }

  const forecast = findForecastForDay(
    day.format("YYYY-MM-DD"),
    forecasts ?? []
  );

  // to-do this needs to show an input field so the user can add a forecast
  if (!forecast) {
    return <>No Data</>;
  }

  return (
    <div
      className="month-day-revenue-container"
      style={{
        display: "flex",
        flex: 1,
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <Span
        style={{
          fontSize: "15px",
          fontWeight: "700",
          fontStyle: "italic",
          color: "var(--color)",
          gap: "5px",
          display: "flex",
          alignItems: "center",
        }}
      >
        <Format dataType="currency" value={forecast.NetAmount} />
        <Tooltip
          background={theme}
          style={{
            borderRadius: "8px",
            border: "1px solid var(--border-color)",
          }}
          tooltipFor={<PlusLined accent="teal" style={{ cursor: "pointer" }} />}
        >
          <div className="week-day-site-event-popover-content">
            Add or edit revenue forecast
          </div>
        </Tooltip>
      </Span>
    </div>
  );
};

export default MonthDayRevenue;
